import Papa from 'papaparse';
import { getPdf } from '../actions/master.js';

/**
*
* @returns
*/
const parseFile = () => new Promise((resolve) => {
    Papa.parse("https://docs.google.com/spreadsheets/d/e/2PACX-1vTi0L6yH9Hb6eC7re-W3c3PlAFTzH0ktkmXE22iuVpyK6wvAMftYNRS0OR3W1Nuy9-_fWx5nHPtCir_/pub?output=csv", {
        download: true,
        header: true,
        complete: (results) => {
            resolve(results.data);
        }
    });
});

/**
 *
 */
export async function fetchTelusDrugIDs() {
    let parsedData = await parseFile();
    return parsedData;
}

/**
 */
export function goToTop() {
    const content = document.getElementById("content");

    if (content) {
        document.getElementById("content").scroll(0, 0);
    } else {
        window.scrollTo(0, 0);
    }
}

/**
 * 
 * @param {*} email 
 * @returns 
 */
export const checkEmail = (email) => {
    const environment = process.env.REACT_APP_ENVIRONMENT;

    if (environment !== 'production') {
        return true;
    }

    return [
        'eric.wein@simplybenefits.ca',
        'jarrod.reimann@simplybenefits.ca',
        'alex.evers@simplybenefits.ca'
    ].includes(email);
};

/**
 * @param ComponentName
 * @param fileName
 * @param dispatch
 * @param downloadParams
 * @returns {Promise<void>}
 */
export const downloadPDFToBrowser = async (ComponentName, fileName, dispatch, downloadParams = {}) => {
    const base64 = await dispatch(getPdf(ComponentName, fileName, downloadParams));

    const linkSource = `data:application/pdf;base64,${ base64 }`;
    const downloadLink = document.createElement("a");

    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
};

/**
 * 
 * @param {*} x
 */
export const numberWithCommas = (x) => Number(x).toFixed(2)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');